import type { Domain } from '@/domain/types'
import { useApiQuery, type QueryState } from '@/api/useApiQuery'

export interface DomainQuery {
  includeInactive?: boolean
  asOf?: string
}

/**
 * Fetches GET /api/domains/{id}. Same response shape as a list item.
 */
export function useDomain(domainId: number, query: DomainQuery = {}): QueryState<Domain> {
  const params = new URLSearchParams()
  if (query.includeInactive) params.set('includeInactive', 'true')
  if (query.asOf) params.set('asOf', query.asOf)
  const qs = params.toString()
  const path = qs ? `/api/domains/${domainId}?${qs}` : `/api/domains/${domainId}`
  return useApiQuery<Domain>(path)
}
